import React, { createContext, useContext, useState } from "react";

const CurrentResultContext = createContext(null);

const CurrentResultProvider = ({ children }) => {
  const [currentResult, setCurrentResult] = useState(null);
  const [buildingGrids, setBuildingGrids] = useState({});
  const [showGrid, setShowGrid] = useState(false);

  return (
    <CurrentResultContext.Provider
      value={{
        currentResult,
        setCurrentResult,
        buildingGrids,
        setBuildingGrids,
        showGrid,
        setShowGrid,
      }}
    >
      {children}
    </CurrentResultContext.Provider>
  );
};

const useCurrentResultContext = () => {
  return useContext(CurrentResultContext);
};

export { CurrentResultProvider, useCurrentResultContext };
